/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import Ajv from 'ajv';

import GalleryItemSchema from '../../config/schemas/GalleryItem.json';
import GroupsSchema from '../../config/schemas/Groups.json';
import ModelDataSchema from '../../config/schemas/ModelData.json';
import PredefinedConfigSchema from '../../config/schemas/PredefinedConfiguration.json';
import ProductDataSchema from '../../config/schemas/ProductData.json';
import RangeSettingsSchema from '../../config/schemas/RangeSettings.json';

const ajv = new Ajv({
	verbose: true,
});
ajv.addSchema(GalleryItemSchema || []);
ajv.addSchema(GroupsSchema || []);
ajv.addSchema(ModelDataSchema || []);
ajv.addSchema(PredefinedConfigSchema || []);
ajv.addSchema(ProductDataSchema || []);
ajv.addSchema(RangeSettingsSchema || []);

export function validateJson(schemaKey: string, data: any): { valid: boolean; error?: string } {
	const valid = ajv.validate(schemaKey, data);
	if (!valid) {
		return { valid: false, error: ajv.errorsText() };
	}

	return { valid: true };
}
